import React from 'react';
import {connect} from 'react-redux';
import CityDropDown from './cityDropDown';


import Logo from './logo';


class Navbar extends React.Component{


  render(){

   return (
    <div className="container">
    <div className="container navbar">
     <div className="jumbotron">

      <div className="row navbar-setting">

        <Logo/>


       <CityDropDown />

      </div>
      </div>
     </div>

     </div>
   )}

}


function mapStateToProps(state) {
  return {
    loader : state.Loader,
    viewport : state.ViewPort
  };
}


export default connect(mapStateToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/navbar.js